module.exports = __webpack_public_path__ + "static/img/jc3.b2c77f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/jc3.png
// module id = exHk
// module chunks = 1